import { render, staticRenderFns } from "./modal-reset-password.vue?vue&type=template&id=56163b86&"
import script from "./modal-reset-password.vue?vue&type=script&lang=js&"
export * from "./modal-reset-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports